<div class="image-container">
  <img src="../../assets/AG_Zest.png" class="image-item" />
</div>
<div class="card">
  <h2 class="card-header">Create Internal User</h2>
  <div class="card-body invalid" *ngIf="invalidSignUpCode">
    <h3>Sign Up link is invalid</h3>
  </div>
  <div class="card-body" *ngIf="validSignUpCode">
    <form [formGroup]="createForm" (ngSubmit)="createAgent()" autocomplete="off">
      <div class="identifier-container">
        <label>Identifier (E-mail):</label>
        <input type="text" class="form-control" formControlName="identifier" [ngClass]="{ 'is-invalid': submitted && f.identifier.errors }" readonly />

        <div *ngIf="submitted && f.identifier.errors" class="invalid-feedback">
          <div *ngIf="f.identifier.errors.required">Identifier required</div>
          <div *ngIf="f.identifier.errors.email">Identifier must be a valid email address</div>
        </div>
      </div>
      <div class="top-container">
        <div class="form-group">
          <label>Password:</label>
          <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required and min. length is 8 characters</div>
            <div *ngIf="f.password.errors.minlength">Min. length is 8 characters</div>
          </div>
        </div>
        <div class="form-group">
          <label>Confirm Password:</label>
          <input type="password" formControlName="confirmPassword" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
            <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required and min. length is 8 characters</div>
          </div>
        </div>
      </div>
      <div class="mid-container">
        <div class="form-group">
          <label>Firstname:</label>
          <input type="text" class="form-control" formControlName="firstname" [ngClass]="{ 'is-invalid': submitted && f.firstname.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.firstname.errors" class="invalid-feedback">
            <div *ngIf="f.firstname.errors.required">Firstname required</div>
          </div>
        </div>

        <div class="form-group">
          <label>Lastname:</label>
          <input type="text" class="form-control" formControlName="lastname" [ngClass]="{ 'is-invalid': submitted && f.lastname.errors }" placeholder="Required field" />

          <div *ngIf="submitted && f.lastname.errors" class="invalid-feedback">
            <div *ngIf="f.lastname.errors.required">Lastname required</div>
          </div>
        </div>
      </div>

      <div class="bot-container">
        <div class="form-group">
          <label for="Phonenumber">Phone number:</label>
          <input type="text" (hasError)="hasError($event)" (countryChange)="onCountryChange($event)" (intlTelInputObject)="telInputObject($event)" class="form-control" formControlName="phonenumber" [ngClass]="{ 'is-invalid': submitted && f.phonenumber.errors }" placeholder="E.g. 12345678" />
          <div *ngIf="submitted && f.phonenumber.errors" class="invalid-feedback">
            <div *ngIf="f.phonenumber.errors.required">Phone number is required</div>
          </div>
        </div>
        <div class="form-group">
          <button [class.black]="isWaitingResponse | async" [disabled]="isWaitingResponse | async" class="save-changes">Create User</button>
        </div>
        <div *ngIf="userCreationSucces" class="succes">User creation was succesful!</div>
        <div *ngIf="userCreationFail" class="error">User creation failed!</div>
      </div>
    </form>
  </div>
  <div class="card-body invalid" *ngIf="userCreationSucces">
    <h3>User: {{ userCreated }}</h3>
    <h3>was succesfully created</h3>
    <button class="gotoLogin" (click)="gotoLogin()">Go to Login</button>
  </div>
</div>
